import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
import { config } from "../../utils/config";
import {
  fetchDataAndMapToField,
  addAddiotionDrivertoExclude,
  waitForCookie,
} from "../../utils/helperFuctions";
import { getCookie } from "../../utils/cookieHandler";
import useReservationLogic from "./useReservationLogic";
import { isDate } from "moment-timezone";

export const damageTypeStatus = [
  { id: "1", name: "Fixed" },
  { id: "2", name: "Pending" },
];
//Roles
const captain = process.env.REACT_APP_CAPTAIN_ID;
const admin = process.env.REACT_APP_ADMIN_ROLE;
const operatorRole = process.env.REACT_APP_OPERATOR_ROLE;
const managerRole = process.env.REACT_APP_MANAGER_ROLE;
const financeRole = process.env.REACT_APP_FINANCE_ROLE;
const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;
const clientRole = process.env.REACT_APP_CLIENT_ROLE;

const ReservationPage = () => {
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole, clientRole];
  const deleteRoles = [admin, managerRole, financeRole];

  const editRoles = [admin, managerRole, financeRole, captain, operatorRole, rentalPartnerRole, clientRole];

  const [currentRole, setCurrentRole] = useState(getCookie("_r"));
  useEffect(() => {
    const fetchCookie = async () => {
      const cookie = await waitForCookie("_r");
      setCurrentRole(cookie);
    };
    if (currentRole == null) {
      fetchCookie();
    }
  }, []);

  const columns = [
    { field: "id", label: "ID", decimalCount: 0, allowSorting: true },
    {
      field: "pickup_date",
      label: "Pickup",
      allowSorting: true,
      showInFilter: true,
      isDate: true,
      // for csv export
      branchCode: "branch.code",
      //
    },
    // {
    //   field: "concat",
    //   label: "MO",
    //   concatBy: " - ",
    //   concat: [{ field: "mileage_option", subvalue: "name" }],
    //   allowSorting: true,
    //   showInFilter: true,
    //   hide: true,
    // },
    {
      field: "return_date",
      label: "Return",
      allowSorting: true,
      showInFilter: true,
      // for csv export
      branchCode: "branch.code",
      //
      isDate: true,
    },
    {
      field: "time_extension",
      subvalue: "date_extended",
      label: "Adjusted return",
      // if it's value is an array
      isArray: true,
      // which item in the array to display
      showValue: "last",
      isDate: true,
      // for csv export
      branchCode: "branch.code",
      //
      allowSorting: true,
      sortingRelationSubValue: "date_extended",
    },
    { field: "reservation_code", label: "Code", allowSorting: true },
    {
      field: "concat",
      label: "Plate",
      allowSorting: true,
      concatBy: " - ",
      concat: [{ field: "vehicle", subvalue: "plate" }],
      showInFilter: true,
    },
    {
      field: "concat",
      label: "Vehicle",
      allowSorting: true,
      concatBy: " - ",
      concat: [
        { field: "vehicle", subvalue: "brand.name" },
        { field: "vehicle", subvalue: "model.name" },
        { field: "vehicle", subvalue: "color.name" },
        { field: "vehicle", subvalue: "year", decimalCount: 0 },
      ],
    },
    {
      field: "concat",
      label: "Branch",
      allowSorting: true,
      concatBy: " ",
      concat: [{ field: "branch", subvalue: "Name" }],
      showInFilter: true,
    },
    {
      field: "concat",
      label: "Customer",
      allowSorting: true,
      concatBy: " ",
      concat: [
        { field: "contact", subvalue: "first_name" },
        { field: "contact", subvalue: "last_name" },
      ],
      // showInFilter: true,
      hide: true,
    },
    {
      field: "contact",
      subvalue: "company.name",
      label: "Company",
      allowSorting: true,
      sortingRelationSubValue: "company.name",
      showInFilter: true,
    },
    {
      field: "channel",
      label: "Channel",
      allowSorting: true,
      showInFilter: true,
    },
    {
      field: "monthly_billing",
      label: "Monthly billing",
      allowSorting: true,
      showInFilter: true,
      hide: true,
    },
    {
      field: "bill_to_company",
      label: "Bill to company",
      allowSorting: true,
      showInFilter: true,
      hide: true,
    },
    {
      field: "billing_cycle",
      label: "Billing cycle",
      allowSorting: true,
      showInFilter: true,
      hide: true,
    },
    {
      field: "COF_number",
      label: "COF number",
      allowSorting: true,
      showInFilter: true,
      hide: true,
    },

    { field: "balance", label: "Balance", decimalCount: 2, allowSorting: true },
    {
      field: "has_pending_billing_events",
      label: "Bill",
      allowSorting: true,
      type: "status",
      values: {
        "True": "text-orange-700 ring-orange-600/20 bg-orange-50",
        "False": "text-green-700 ring-green-600/20 bg-green-50",
      },
      displayValues: {
        "True": "Pending",
        "False": "Billed",
        "": "N/A",
      },
      showInFilter: true,
    },
    {
      field: "status",
      label: "Status",
      allowSorting: true,
      type: "status",
      values: {
        "Picked up": "text-blue-700 ring-blue-600/20 bg-blue-50",
        Draft: "text-gray-600 bg-gray-50 ring-gray-500/10",
        Returned: "text-purple-700 ring-purple-600/40 bg-purple-50",
        Closed: "text-green-700 ring-green-600/20 bg-green-50",
        Canceled: "text-red-700 ring-red-600/20 bg-red-50",
        Open: "text-orange-400 bg-orange-50 ring-orange-400/10",
      },
      showInFilter: true,
    },
  ];

  const { apiRoute, tabsData, initFields } = useReservationLogic();

  const [fields, setfields] = useState(initFields);

  const loadOptions = async () => {
    try {
      const temp = [...initFields];
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(
          config,
          "branches",
          "branch",
          temp,
          "Name",
          "currency",
          undefined,
          "code"
        ),
        fetchDataAndMapToField(
          config,
          "contacts",
          "contact",
          temp,
          undefined,
          undefined,
          undefined,
          "company"
        ),
        fetchDataAndMapToField(
          config,
          "currencies",
          "currency",
          temp,
          "code",
          "symbol"
        ),
        fetchDataAndMapToField(config, "vehicleclasses", "vehicle_class", temp),
        addAddiotionDrivertoExclude(
          config,
          temp,
          "reservation_addons",
          "additional_drivers"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Reservations" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="reservation"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default ReservationPage;
